// extracted by mini-css-extract-plugin
export default {"article":"Article_article__psDdS","link":"Article_link__r2gv3","actions":"Article_actions__pS5dt","action":"Article_action__7sfNi"};